import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import {UserRoleEnum} from '@/enums/userRolesEnum'
import {IssuableController, StateLicense} from "@/components/provider/cards/issuables/IssuableModels";
import {getRestParamErrorMessage} from "@/utils/serverErrorMessageUtil";
import StateLicenseDetail from "@/components/provider/cards/stateLicenses/StateLicenseDetail";
import IssuableCard from "@/components/provider/cards/issuables/IssuableCard";
import HttpMixin from "@/mixins/HttpMixin";

export default Vue.component('state-licenses-card', {
  name: 'StateLicensesCard',
  data () {
    return {
      hasCompact: false
    };
  },
  components: {
    IssuableCard,
    VueSimpleSpinner,
    StateLicenseDetail
  },
  mixins: [HttpMixin],
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    },
    providerId(): number {
      return parseInt(this.$route.params.providerId, 10);
    },
    compactUrl(): string {
      return `/providers/${this.providerId}/compact`;
    }
  },
  watch: {
    async providerId() {
      await this.loadCompactInfo();
    }
  },
  async created() {
    await this.loadCompactInfo();
  },
  methods: {
    async loadCompactInfo() {
      const results = await this.httpGet<{ hasCompact: boolean }>(this.compactUrl, 'An error occurred retrieving Has Compact.');
      this.hasCompact = results ? results.hasCompact : false;
    },
    async updateCompact() {
      if (this.isProviderUser) {
        return;
      }
      const results = await this.httpPut(this.compactUrl, 'An error occurred updating Has Compact.', { hasCompact: !this.hasCompact });
      if (results) {
        this.hasCompact = !this.hasCompact;
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'Updated Has Compact.'
        });
      }
    },
    issuableController() : IssuableController<StateLicense> {
      return {
        entityName: "State License",
        entityType: 3,
        documentUploadPath: "provider/stateLicense/",
        primaryIdField: "stateLicenseId",
        createNewModel(providerId: string): any {
          return {
            "providerId": providerId,
            "stateLicenseId": "",
            "licenseNumber": "",
            "stateId": "",
            "stateFull": "",
            "stateAbbrev": "",
            "issuedDate": null,
            "expirationDate": null,
            "expirationNoticeSetting": 0,
            "expirationNoticeDate": null,
            "isNew": true,
            "isEditing": true
          }
        },
        getAllForProvider(providerId: string): Promise<any> {
          return HTTP.get('/api/providers/' + providerId + '/stateLicenses')
        },
        createData(providerId: string, issuable: StateLicense): Promise<any> {
          return HTTP.post('/api/providers/' + providerId + '/stateLicenses', issuable);
        },
        deleteData(providerId: string, id: number): Promise<any> {
          return HTTP.delete('/api/providers/' + providerId + '/stateLicenses/' + id);
        },
        deleteDocument(id: number): Promise<any> {
          return HTTP.delete('/api/facilityStateLicenseDocument/' + id );
        },
        errorsExistOnDynamicFields(issuable: StateLicense): boolean {
          return issuable.stateIdErrorMessage.length + issuable.licenseNumberErrorMessage.length > 0;
        },
        setErrorsOnDynamicFields(issuable: StateLicense, error: any): void {
          issuable.stateIdErrorMessage = getRestParamErrorMessage(error, 'stateId');
          issuable.licenseNumberErrorMessage = getRestParamErrorMessage(error, 'licenseNumber');
        },
        updateData(providerId: string, issuable: StateLicense): Promise<any> {
          return HTTP.put('/api/providers/' + providerId + '/stateLicenses', issuable)
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/stateLicenses/StateLicensesCard.ts